var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / blockchain / select / Ethereum default") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-/-blockchain-/-select-/-Ethereum-default",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#4884E8",
    strokeWidth: 2,
    fill: "#FFFFFF",
    cx: 20,
    cy: 20,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ethereum-eth-logo",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4884E8",
    points: "7.36639058 0 7.2053735 0.546932001 7.2053735 16.416227 7.36639058 16.5768683 14.7325933 12.2226432"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#91B5F1",
    points: "7.36639058 0 0 12.2226432 7.36639058 16.5768683 7.36639058 8.87435219"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4884E8",
    points: "7.36639058 17.9715355 7.27564233 18.0821995 7.27564233 23.7350827 7.36639058 24 14.7371025 13.619565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#91B5F1",
    points: "7.36639058 24 7.36639058 17.9715355 0 13.619565"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2B61BD",
    points: "7.36639058 16.5768683 14.7325933 12.2226432 7.36639058 8.87435219"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4884E8",
    points: "0 12.2226432 7.36639058 16.5768683 7.36639058 8.87435219"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthTab);
export default __webpack_public_path__ + "static/media/ethTab.aa539891.svg";
export { ForwardRef as ReactComponent };